// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1WcPQ","content":"GlobalSearch_content__EZF0l"};